import { ArrowUp, ArrowDown, ArrowLeft, ArrowRight } from "lucide-react";

const TouchDPad = ({ onInput, isLocked }) => {
  const btnClass = `border border-white/10 bg-black/60 p-3 text-[#FFE800] hover:border-[#FFE800] ${
    isLocked ? "opacity-40 cursor-not-allowed" : ""
  }`;

  return (
    <div className="grid grid-cols-3 gap-3" data-testid="practice-dpad">
      <div />
      <button
        onClick={() => onInput("up")}
        className={btnClass}
        disabled={isLocked}
        data-testid="input-pad-up"
      >
        <ArrowUp className="mx-auto h-5 w-5" />
      </button>
      <div />
      <button
        onClick={() => onInput("left")}
        className={btnClass}
        disabled={isLocked}
        data-testid="input-pad-left"
      >
        <ArrowLeft className="mx-auto h-5 w-5" />
      </button>
      <button
        onClick={() => onInput("down")}
        className={btnClass}
        disabled={isLocked}
        data-testid="input-pad-down"
      >
        <ArrowDown className="mx-auto h-5 w-5" />
      </button>
      <button
        onClick={() => onInput("right")}
        className={btnClass}
        disabled={isLocked}
        data-testid="input-pad-right"
      >
        <ArrowRight className="mx-auto h-5 w-5" />
      </button>
    </div>
  );
};

export default TouchDPad;
